(function () {
  "use strict";
  if (window.__pbxWishDrawer) return;
  window.__pbxWishDrawer = true;

  var KEY = "pbx_wishlist";
  var src = (document.currentScript && document.currentScript.src) || "";
  var cssHref = src.replace(/pbx-wishlist\.js.*$/, "pbx-wishlist.css");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var root, panel, list, countEl, closeBtn, lastFocus, cache = {};

  function getList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setList(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "PLN";
    try { return new Intl.NumberFormat(document.documentElement.lang || "pl-PL", { style: "currency", currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + " " + cur; }
  }
  function syncHearts() {
    var n = getList().length;
    document.querySelectorAll(".pbx-wish-count").forEach(function (el) { el.textContent = String(n); });
    document.querySelectorAll("[data-wish-id]").forEach(function (el) {
      var on = getList().indexOf(el.dataset.wishId) !== -1;
      if (el.classList.contains("pbx-wish")) el.classList.toggle("is-active", on);
      el.setAttribute("aria-pressed", String(on));
    });
  }

  function build() {
    if (root) return;
    var l = document.createElement("link"); l.rel = "stylesheet"; l.href = cssHref; document.head.appendChild(l);
    root = document.createElement("div");
    root.className = "pbx-wd";
    root.hidden = true;
    root.innerHTML =
      '<div class="pbx-wd-overlay" data-wd-close></div>' +
      '<aside class="pbx-wd-panel" role="dialog" aria-modal="true" aria-labelledby="pbx-wd-title" tabindex="-1">' +
        '<header class="pbx-wd-head"><h2 id="pbx-wd-title">Lista życzeń <span class="pbx-wd-count"></span></h2>' +
        '<button type="button" class="pbx-wd-x" data-wd-close aria-label="Zamknij listę życzeń">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg></button></header>' +
        '<div class="pbx-wd-list" aria-live="polite"></div>' +
      '</aside>';
    document.body.appendChild(root);
    panel = root.querySelector(".pbx-wd-panel");
    list = root.querySelector(".pbx-wd-list");
    countEl = root.querySelector(".pbx-wd-count");
    closeBtn = root.querySelector(".pbx-wd-x");
    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-wd-close]")) { close(); return; }
      var rm = e.target.closest("[data-wd-remove]");
      if (rm) { remove(rm.dataset.wdRemove); return; }
      var add = e.target.closest("[data-wd-add]");
      if (add) addToCart(add);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !root.hidden) close(); });
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("nf"); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function itemHtml(p, handle) {
    var title = String(p.title).replace(" - Odlewka Perfum", "");
    var min = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
    var multi = p.variants.length > 1;
    var avail = p.variants.filter(function (v) { return v.available; })[0];
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_240x$1$2") : "";
    var brand = ((p.tags || []).filter(function (t) { return String(t).indexOf("rodzina:") !== 0; })[0]) || p.vendor;
    return '<article class="pbx-wd-item" data-handle="' + esc(handle) + '">' +
      '<a class="pbx-wd-thumb" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : "") + "</a>" +
      '<div class="pbx-wd-info">' +
        '<p class="pbx-wd-brand">' + esc(brand) + "</p>" +
        '<a class="pbx-wd-name" href="' + esc(p.url) + '">' + esc(title) + "</a>" +
        '<p class="pbx-wd-price">' + (multi ? "Od " : "") + money(min) + "</p>" +
        '<div class="pbx-wd-actions">' +
          (avail
            ? (multi
                ? '<a class="pbx-wd-btn" href="' + esc(p.url) + '">Wybierz rozmiar</a>'
                : '<button type="button" class="pbx-wd-btn" data-wd-add="' + avail.id + '">Dodaj do koszyka</button>')
            : '<span class="pbx-wd-soldout">Wyprzedane</span>') +
        "</div>" +
      "</div>" +
      '<button type="button" class="pbx-wd-rm" data-wd-remove="' + esc(handle) + '" aria-label="Usuń z listy życzeń">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg></button>' +
    "</article>";
  }

  function render() {
    var handles = getList();
    countEl.textContent = handles.length ? "(" + handles.length + ")" : "";
    if (!handles.length) {
      list.innerHTML = '<div class="pbx-wd-empty"><p>Twoja lista życzeń jest pusta.</p><p class="pbx-wd-hint">Kliknij serce przy zapachu, aby zapisać go na później.</p><a class="pbx-wd-btn" href="/collections/all">Przeglądaj perfumy</a></div>';
      return;
    }
    list.innerHTML = '<p class="pbx-wd-loading">Ładowanie…</p>';
    Promise.all(handles.map(fetchProduct)).then(function (ps) {
      if (root.hidden) return;
      var html = "";
      ps.forEach(function (p, i) { if (p) html += itemHtml(p, handles[i]); });
      list.innerHTML = html || '<div class="pbx-wd-empty"><p>Nie udało się wczytać produktów.</p></div>';
    });
  }

  function remove(handle) {
    setList(getList().filter(function (h) { return h !== handle; }));
    syncHearts();
    var el = list.querySelector('[data-handle="' + handle.replace(/"/g, "") + '"]');
    if (el) el.remove();
    if (!getList().length) render(); else countEl.textContent = "(" + getList().length + ")";
  }

  function addToCart(btn) {
    var drawer = document.querySelector("cart-drawer");
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = "Dodaję…";
    var body = { items: [{ id: Number(btn.dataset.wdAdd), quantity: 1 }] };
    if (drawer) body.sections = "cart-drawer,cart-icon-bubble";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || "err");
        btn.textContent = "Dodano";
        if (drawer && drawer.renderContents && state.sections) {
          close();
          if (state.items && state.items[0]) state.id = state.items[0].id;
          drawer.renderContents(state);
        } else if (state.sections === undefined) { window.location.href = "/cart"; }
      })
      .catch(function () { btn.textContent = "Spróbuj ponownie"; })
      .then(function () { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1800); });
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    render();
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add("is-open"); });
    document.documentElement.style.overflow = "hidden";
    setTimeout(function () { closeBtn.focus(); }, reduce ? 0 : 60);
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    setTimeout(function () { root.hidden = true; }, reduce ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href$="/pages/lista-zyczen"], [data-pbx-wish-open]');
    if (!a) return;
    e.preventDefault();
    open();
  });
  window.addEventListener("storage", function (e) { if (e.key === KEY) { syncHearts(); if (root && !root.hidden) render(); } });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-wish-id]") && root && !root.hidden) setTimeout(render, 30);
  });
  window.PBX_WISH_DRAWER = { open: open, close: close };
})();
